const React = require('react');
const { default: RightArrow } = require('@mui/icons-material/ArrowRightAlt');
const { USERS_SORT_TYPE } = require('utils/constants');

const internals = {};

internals.AlphabeticalLabel = function AlphabeticalLabel() {

    return <div style={{ display: 'flex', alignItems: 'center' }}>Name (A <RightArrow /> Z)</div>;
};

internals.asArray = (value) => Array.isArray(value) ? value : [];

internals.filterFieldTextFieldProps = ({
    ariaLabel,
    fieldStyles
}) => ({
    variant: 'filled',
    fieldStyles,
    InputLabelProps: {
        shrink: true
    },
    InputProps: {
        disableUnderline: true
    },
    inputProps: {
        'aria-label': ariaLabel
    }
});

internals.buildRoleOptions = (availableRoleGroups) => {
    const roleGroups = internals.asArray(availableRoleGroups);

    if (!roleGroups.length) {
        return [];
    }

    return [{
        value: 'all',
        label: 'All'
    }].concat(roleGroups.map((option) => ({
        value: option.name,
        label: option.label
    })));
};

internals.resolveRoleGroupFilterValue = ({
    availableRoleGroups,
    roleGroupFilter
}) => {
    const roleGroups = internals.asArray(availableRoleGroups);

    if (!roleGroups.length) {
        return '';
    }

    const matchingRoleGroup = roleGroups.find(({ name }) => name === roleGroupFilter);

    if (matchingRoleGroup) {
        return roleGroupFilter;
    }

    return 'all';
};

internals.buildFields = ({
    availableRoleGroups,
    canSearchHometown,
    canSearchHousing,
    canSeeDisabledUsers,
    filterFieldStyles,
    onSortChange,
    setRoleGroupFilter
}) => {
    const roleOptions = internals.buildRoleOptions(availableRoleGroups);

    return [{
        type: 'group',
        fields: [
            {
                name: 'sortType',
                type: 'SelectField',
                label: 'Show By',
                options: internals.buildSortOptions({
                    canSearchHometown,
                    canSearchHousing,
                    canSeeDisabledUsers
                }),
                onChange: onSortChange,
                textFieldProps: internals.filterFieldTextFieldProps({
                    ariaLabel: 'Show By',
                    fieldStyles: filterFieldStyles
                })
            },
            roleOptions.length && {
                name: 'roleGroupFilter',
                type: 'SelectField',
                label: 'Role',
                options: roleOptions,
                onChange: (value) => {

                    setRoleGroupFilter(value?.filter || value);
                },
                textFieldProps: internals.filterFieldTextFieldProps({
                    ariaLabel: 'Role',
                    fieldStyles: filterFieldStyles
                })
            }
        ].filter(Boolean)
    }];
};

internals.buildSortOptions = ({
    canSearchHometown,
    canSearchHousing,
    canSeeDisabledUsers
}) => ([
    {
        value: USERS_SORT_TYPE.BEST_MATCH,
        label: 'Best Match'
    },
    {
        value: USERS_SORT_TYPE.PASSION,
        label: 'Passion Match'
    },
    canSearchHometown && {
        value: USERS_SORT_TYPE.HOMETOWN,
        label: 'Hometown'
    },
    canSearchHousing && {
        value: USERS_SORT_TYPE.HOUSING,
        label: 'Lives Nearby'
    },
    {
        value: USERS_SORT_TYPE.NEWEST,
        label: 'Newest'
    },
    {
        value: USERS_SORT_TYPE.ALPHABETICAL,
        label: <internals.AlphabeticalLabel />
    },
    {
        value: USERS_SORT_TYPE.RANDOM,
        label: 'Surprise Me'
    },
    {
        value: USERS_SORT_TYPE.CONNECTION_STATUS,
        label: 'Invitations'
    },
    {
        value: USERS_SORT_TYPE.MY_CONNECTIONS,
        label: 'My Connections'
    },
    canSeeDisabledUsers && {
        value: USERS_SORT_TYPE.DISABLED,
        label: 'Closed Accounts'
    }
].filter(Boolean));

internals.buildDefaults = ({
    availableRoleGroups,
    discoverSortType,
    roleGroupFilter
}) => ({
    roleGroupFilter: internals.resolveRoleGroupFilterValue({
        availableRoleGroups,
        roleGroupFilter
    }),
    sortType: discoverSortType || USERS_SORT_TYPE.BEST_MATCH
});

module.exports.buildFormConfig = function buildFormConfig(props) {

    const {
        onSubmit
    } = props;

    return {
        formId: 'discover-filter-form',
        fields: internals.buildFields(props),
        defaults: internals.buildDefaults(props),
        onSubmit
    };
};
module.exports.internals = internals;
